export var COMPONENT_CLASS_NAME = 'galaxy-search';
export var MENU_GALAXY_EVENT_INPUT = 'MENU_GALAXY_EVENT_INPUT';
export default COMPONENT_CLASS_NAME;
//# sourceMappingURL=Search.constant.js.map